import Vue from 'vue';
import {Vue as _Vue} from "vue/types/vue";
import {VCheckbox} from "vuetify/lib";

const checkBox = VCheckbox as unknown as typeof _Vue;

export default Vue.extend({
	name: 'AsiCheckbox',
	extends: checkBox,
	props: {
		hideDetails: {
			type: String,
			default: 'auto',
		},
		rules: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		classes(): Record<string, boolean> {
			const base = (this as any).$options.extends.options.computed.classes.call(this);
			const hasRequired = this.rules.some((rule: any) => rule?.isRequired);

			return {
				...base,
				'input-required': hasRequired,
			};
		},
	},
});
